<p-dialog [(visible)]="display" (onHide)="onHide()" (onShow)="onShow()" [modal]="true" [draggable]="false"
  [breakpoints]="{'960px': '90vw', '640px': '100vw'}" [style]="{width: '30vw', maxHeight: '90vh'}" >
  <ng-template class="p-dialog-title" pTemplate="header">
    <div>
      <i class="fa fa-plus me-2" aria-hidden="true"></i>
      <strong>Detalle de la actividad</strong>
    </div>
  </ng-template>

  <div *ngIf="subject_type === 'HistorialTramas'" class="mb-4">
    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Detalles del Historial</h5>
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>

      <div class="mb-3 mt-2">
        <label class="fw-semibold text-dark d-block mb-2">Rango de búsqueda:</label>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label small text-muted">Desde</label>
            <div class="bg-light border rounded p-2">
              <strong>{{ data.fecha_desde | date:'short' }}</strong>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label small text-muted">Hasta</label>
            <div class="bg-light border rounded p-2">
              <strong>{{ data.fecha_hasta | date:'short' }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <label class="fw-semibold text-dark d-block mb-2">Vehículos procesados:</label>

        <div *ngFor="let v of data.vehiculos" class="">
          <div class="row g-3">
            <div class="col-md-4 col-12">
              <label class="form-label small text-muted">Vehículo</label>
              <div class="px-2 py-1">
                <strong>{{ v.nombre }}</strong>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <label class="form-label small text-muted">IMEI</label>
              <div class="px-2 py-1">
                <strong>{{ v.imei }}</strong>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <label class="form-label small text-muted">Operación</label>
              <div class="px-2 py-1">
                <strong>{{ v.nameoperation }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="text-center text-muted small" *ngIf="!data">
      <div class="spinner-border spinner-border-sm text-secondary me-2" role="status"></div>
      Cargando historial de eventos...
    </div>
  </div>

  <div *ngIf="subject_type === 'GroupConvoy'" class="mb-4">
    <div class="mb-3 mt-1" *ngIf="data">
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>

      <div class="row g-3">
        <label class="fw-semibold text-dark d-block mb-2">Detalle de la alerta:</label>
        <div class="row col-12">
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Nombre</label>
            <div class="px-2 py-1">
              <strong>{{ v.nombre }}</strong>
            </div>
          </div>


          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Tipo</label>
            <div class="px-2 py-1">
              <strong>{{ v.enm_type }}</strong>
            </div>
          </div>


          <div class="col-md-4 col-12" *ngIf="data.descripcion">
            <label class="form-label small text-muted">Descripción</label>
            <div class="px-2 py-1">
              <strong>{{ v.descripcion }}</strong>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="text-center text-muted small" *ngIf="!data">
      <div class="spinner-border spinner-border-sm text-secondary me-2" role="status"></div>
      Cargando detalles de la actividad...
    </div>
  </div>


  <div *ngIf="subject_type === 'UserTracker'">
    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Detalles</h5>
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>
      <app-activity-info [activity]="activity"></app-activity-info>

      <div class="mt-4">
        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Vehículo involucrados:</label>
          <div class="px-2 py-1">
            <strong>{{data.vehiculos || 'Sin información' }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="subject_type === 'CircularZone'">
    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Zona Circular</h5>
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>


      <div class="mt-4">

        <div class="row g-3">
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Nombre</label>
            <div class="px-2 py-1">
              <strong>{{ data.var_nombre }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Área (m²)</label>
            <div class="px-2 py-1">
              <strong>{{ data.dbl_area }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Radio (m)</label>
            <div class="px-2 py-1">
              <strong>{{ data.dbl_radio }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Línea</label>
            <div class="px-2 py-1">
              <strong>{{ data.enm_tipo_linea }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Color</label>
            <div class="px-2 py-1 d-flex align-items-center gap-2">
              <strong style="color: black;">{{ data.var_color }}</strong>
              <span class="color-preview" [style.backgroundColor]="data.var_color"
                style="display:inline-block; width:20px; height:20px; border:1px solid #ccc; border-radius: 3px;">
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

  <div *ngIf="subject_type === 'Zone'">


    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Zona Poligonal</h5>
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>


      <div class="mt-4">


        <div class="row g-3">
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Nombre</label>
            <div class="px-2 py-1">
              <strong>{{ data.nombre_zona }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Descripción</label>
            <div class="px-2 py-1">
              <strong>{{ data.descripcion || 'Sin descripción' }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Tipo de zona</label>
            <div class="px-2 py-1">
              <strong>{{ data.zone_type }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Velocidad máxima (km/h)</label>
            <div class="px-2 py-1">
              <strong>{{ data.vel_max }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Color</label>
            <div class="px-2 py-1 d-flex align-items-center gap-2">
              <strong style="color: black;">{{ data.color_zona }}</strong>
              <span class="color-preview" [style.backgroundColor]="data.color_zona"
                style="display:inline-block; width:20px; height:20px; border:1px solid #ccc; border-radius: 3px;">
              </span>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div *ngIf="subject_type === 'API_postgres/Driver/update'">

    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Actualización de Conductor</h5>
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>


      <div class="mt-4">

        <div class="row g-3">
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Nombre</label>
            <div class="px-2 py-1">
              <strong>{{ data.nombre_conductor }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">DNI</label>
            <div class="px-2 py-1">
              <strong>{{ data.dni_conductor }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Tipo de documento</label>
            <div class="px-2 py-1">
              <strong>{{ data.tipo_documento }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Estado</label>
            <div class="px-2 py-1">
              <strong [ngClass]="{ 'text-success': data.activo === 'true', 'text-danger': data.activo !== 'true' }">
                {{ data.activo === 'true' ? 'Activo' : 'Inactivo' }}
              </strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Última actualización</label>
            <div class="px-2 py-1">
              <strong>{{ data.updated_at | date:'short' }}</strong>
            </div>
          </div>
        </div>


      </div>
    </div>

  </div>


  <div *ngIf="subject_type === 'API_postgres/Driver/create'">

    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Registro de Nuevo Conductor</h5>
      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>


      <div class="mt-4">
        <div class="row g-3">
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Nombre</label>
            <div class="px-2 py-1">
              <strong>{{ data.nombre_conductor }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">DNI</label>
            <div class="px-2 py-1">
              <strong>{{ data.dni_conductor }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Tipo de documento</label>
            <div class="px-2 py-1">
              <strong>{{ data.tipo_documento }}</strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Estado</label>
            <div class="px-2 py-1">
              <strong [ngClass]="{ 'text-success': data.activo === 'true', 'text-danger': data.activo !== 'true' }">
                {{ data.activo === 'true' ? 'Activo' : 'Inactivo' }}
              </strong>
            </div>
          </div>

          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Fecha de registro</label>
            <div class="px-2 py-1">
              <strong>{{ data.created_at | date:'short' }}</strong>
            </div>
          </div>
        </div>



      </div>
    </div>

  </div>
  <div *ngIf="subject_type === 'EventUser'" class="mb-4">
    <div class="mb-3 mt-1" *ngIf="data">
      <h5 class="fw-semibold mb-3">Configuración de Evento Personalizado</h5>

      <p class="text-muted" [innerHTML]="removeIp(message)"></p>
      <app-activity-info [activity]="activity"></app-activity-info>

      <div class="row g-3 mt-3 mb-3">
        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Nombre del evento</label>
          <div class="px-2 py-1">
            <strong>{{ data.nombre || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Tipo</label>
          <div class="px-2 py-1">
            <strong>{{ data.tipo || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">ID del evento</label>
          <div class="px-2 py-1">
            <strong>{{ data.event_id || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Tipo de evento</label>
          <div class="px-2 py-1">
            <strong>{{ data.event_type || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Velocidad límite (km/h)</label>
          <div class="px-2 py-1">
            <strong>{{ data.velocidad_limite_infraccion || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Tiempo límite (segundos)</label>
          <div class="px-2 py-1">
            <strong>{{ data.tiempo_limite_infraccion || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Evaluación automática</label>
          <div class="px-2 py-1">
            <strong [ngClass]="{
              'text-success': data.bol_evaluation === 'true',
              'text-danger': data.bol_evaluation !== 'true'
            }">
              {{ data.bol_evaluation === 'true' ? 'Sí' : 'No' }}
            </strong>
          </div>
        </div>

        <div class="col-md-4 col-12">
          <label class="form-label small text-muted">Vehículos asociados</label>
          <div class="px-2 py-1">
            <strong>{{ data.imei?.split(',').length || 0 }}</strong>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label class="fw-semibold text-dark d-block mb-2">Notificaciones</label>

        <div class="row g-3">
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">Email</label>
            <div class="px-2 py-1">
              <strong>{{ data.notificacion_email === 'true' ? 'Sí' : 'No' }}</strong>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">SMS</label>
            <div class="px-2 py-1">
              <strong>{{ data.notificacion_sms === 'true' ? 'Sí' : 'No' }}</strong>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <label class="form-label small text-muted">WhatsApp</label>
            <div class="px-2 py-1">
              <strong>{{ data.notificacion_whatsapp === 'true' ? 'Sí' : 'No' }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center text-muted small" *ngIf="!data">
      <div class="spinner-border spinner-border-sm text-secondary me-2" role="status"></div>
      Cargando configuración del evento...
    </div>
  </div>

  <div *ngIf="subject_type == 'API_postgres/Driver/delete'">
    <div class="mb-3 mt-1" *ngIf="data">
  
      <h5 class="fw-semibold mb-3">Eliminacion de conductor</h5>

      <p class="text-muted" [innerHTML]="removeIp(message)"></p>

      <app-activity-info [activity]="activity"></app-activity-info>

      <div class="row mt-3">
        <div class="col-md-6 col-12 mb-2">
          <label class="form-label small text-muted">Nombre</label>
          <div class="px-2 py-1">
            <strong>{{ data.nombre_conductor }}</strong>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2" *ngIf="data.dni_conductor">
          <label class="form-label small text-muted">DNI</label>
          <div class="px-2 py-1">
            <strong>{{ data.dni_conductor }}</strong>
          </div>
        </div>

        <div class="col-md-3 col-6 mb-2" *ngIf="data.tipo_documento">
          <label class="form-label small text-muted">Tipo de documento</label>
          <div class="px-2 py-1">
            <strong>{{ data.tipo_documento }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-6 mb-2">
          <label class="form-label small text-muted">Estado</label>
          <div class="px-2 py-1">
            <strong [ngClass]="{ 'text-success': data.activo === 'true', 'text-danger': data.activo !== 'true' }">
              {{ data.activo === 'true' ? 'Activo' : 'Inactivo' }}
            </strong>
          </div>
        </div>

        <div class="col-md-4 col-6 mb-2">
          <label class="form-label small text-muted">Tipo</label>
          <div class="px-2 py-1">
            <strong>{{ data.tipo || 'No disponible' }}</strong>
          </div>
        </div>

        <div class="col-md-4 col-12 mb-2">
          <label class="form-label small text-muted">Fecha de registro</label>
          <div class="px-2 py-1">
            <strong>{{ data.created_at | date:'short' }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="false">
    <div class="dialog-body-container">

      <div style="width: 100%; max-width: 100%; margin-bottom: 1.5rem;">

        <div class="row">
          <div *ngIf="old" [ngClass]="{'d-none': !display_old, 'd-block': display_old,'col-0': !old, 'col-5': old}">
            <b>Antiguo</b>
          </div>
          <div *ngIf="old" [ngClass]="{'d-none': !display_old, 'd-flex': display_old, 'col-0': !old, 'col-2': old}">

          </div>
          <div *ngIf="attributes"
            [ngClass]="{'d-none': !display_new, 'd-block': display_new, 'col-12': !old, 'col-5': old}">
            <b>Nuevo</b>
          </div>
          <hr *ngIf="attributes || old" [ngClass]="{'d-none': !display_new, 'd-block': display_new}">
          <div *ngIf="old" [ngClass]="{'d-none': !display_old, 'd-block': display_old, 'col-0': !old, 'col-5': old}">

            <app-audit-info-activity [properties]="old" [subject_type]="subject_type"
              [color]="'red'"></app-audit-info-activity>

          </div>
          <div *ngIf="old"
            [ngClass]="{'d-none': !display_old, 'd-flex align-items-center': display_old, 'col-0': !old, 'col-2': old}">
            <i class="fas fa-arrow-right m-auto"></i>
          </div>
          <div [ngClass]="{'col-12': !old, 'col-5': old}">

            <app-audit-info-activity [properties]="attributes" [subject_type]="subject_type"
              [color]="'green'"></app-audit-info-activity>

          </div>
        </div>
      </div>

    </div>

  </div>

</p-dialog>